





























import { Component, Vue, Prop, Emit, Model } from "vue-property-decorator";
import { DxTextBox, DxButton as DxTextBoxButton } from 'devextreme-vue/text-box';

@Component({
  components: {
    DxTextBox,
    DxTextBoxButton
  }
})
export default class FilePicker extends Vue {
  @Prop({
    required: false
  })
  public value!: any;

  @Prop() public nullable!: boolean;

  @Prop() public accept!: string;

  public get isNullableField(): boolean {
    return this.nullable === true;
  }

  public get isNullableButtonVisible(): boolean {
    return (this.value !== null && this.value !== void 0);
  }

  public resetButton = {
    icon: 'fa fa-window-close',
    type: 'danger',

    onClick: () => {
      this.value = null;
      this.emitModelChange(this.value);
    }
  }

  public uploadButton = {
      icon: 'fa fa-upload',
      type: 'default',
      onClick: () => {
        console.info('-> internal file picker is', this.$refs['internal-file-picker']);
        (this.$refs['internal-file-picker'] as any).click();
      }
  }

  public onInternalFilePickerChange(event: any) {
      if (event && event.target && event.target.files) {
          [...event.target.files].forEach( file => {
              const {
                name,
                type,
                size
              } = file;
              const fReader = new FileReader();
              fReader.readAsDataURL(file);
              fReader.onload = () => {
                if (fReader.result && typeof(fReader.result) === 'string') {
                    this.value = {
                        name,
                        filename: name,
                        type,
                        dimensione: size,
                        base64: (fReader.result).split(',')[1]
                    }
                    this.emitModelChange(this.value);
                }
                else {
                    alert('Si è verificato un errore tecnico. contattare l\'assistenza.');
                }
              }
          });
      }
  }

  @Emit('input')
  public emitModelChange(modelValue: any) {
    console.info('-> emitted modelChange to', modelValue);
  }

  public get valueText(): string {
      return (this.value && this.value.name) || '';
  }

  constructor() {
    super();
  }

  async mounted() {
    // console.info('this.value is', this.value)
  }
}
